// extracted by mini-css-extract-plugin
module.exports = {"VidaDropdownContainer":"VidaDropdown_VidaDropdownContainer__3GRQ2","LabelContainer":"VidaDropdown_LabelContainer__1Zce2","DropdownSelect":"VidaDropdown_DropdownSelect__2Bbt8"};